module.exports = __webpack_public_path__ + "static/media/tree.3e47447d.svg";